module.exports = __webpack_public_path__ + "img/456.f441773d.jpg";